import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import WinnerModal from './components/WinnerModal';
import Login from './pages/Login';
import Home from './pages/Home';
import UserDetails from './pages/UserDetails';
import Categories from './pages/Categories';
import CategoryDetail from './pages/CategoryDetail';
import AdminWinners from './pages/AdminWinners';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Unsubscribe from './pages/Unsubscribe';
import Rules from './pages/Rules';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="app">
      {user && <Navbar />}
      <WinnerModal />
      <main className="main-content">
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/user/:userId/group/:groupId" element={
            <ProtectedRoute>
              <UserDetails />
            </ProtectedRoute>
          } />
          <Route path="/categories" element={
            <ProtectedRoute>
              <Categories />
            </ProtectedRoute>
          } />
          <Route path="/categories/:category" element={
            <ProtectedRoute>
              <CategoryDetail />
            </ProtectedRoute>
          } />
          <Route path="/rules" element={
            <ProtectedRoute>
              <Rules />
            </ProtectedRoute>
          } />
          <Route path="/admin/winners" element={
            <ProtectedRoute adminOnly>
              <AdminWinners />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
